import React from "react";
import "./Loader.css";

const Loader = ({ message = "Loading..." }) => (
  <div className="loader-overlay">
    <div className="loader-box">
      <div className="loader-spinner" />
      <div className="loader-message">{message}</div>
    </div>
  </div>
);

export default Loader;